module.exports = __webpack_public_path__ + "img/hongxia.a8934507.png";